import type { CrownDiscoverySource } from "@/lib/analytics/story-analytics";

export const CROWN_DISCOVERY_FILTER_OPTIONS = [
    {
        value: "most-crowned",
        label: "Most Crowned",
        shortLabel: "Most Crowned",
        source: "crown_most",
    },
    {
        value: "ascending",
        label: "Ascending",
        shortLabel: "Ascending",
        source: "crown_ascending",
    },
    {
        value: "fresh-finds",
        label: "Fresh Finds",
        shortLabel: "Fresh Finds",
        source: "crown_fresh",
    },
] as const satisfies readonly {
    value: string;
    label: string;
    shortLabel: string;
    source: CrownDiscoverySource;
}[];

export type CrownDiscoveryFilter =
    (typeof CROWN_DISCOVERY_FILTER_OPTIONS)[number]["value"];

const CROWN_DISCOVERY_FILTER_SET = new Set<string>(
    CROWN_DISCOVERY_FILTER_OPTIONS.map((option) => option.value),
);

export function isCrownDiscoveryFilter(
    value: unknown,
): value is CrownDiscoveryFilter {
    return (
        typeof value === "string" && CROWN_DISCOVERY_FILTER_SET.has(value)
    );
}

export function crownDiscoveryFilterOption(filter: CrownDiscoveryFilter) {
    return CROWN_DISCOVERY_FILTER_OPTIONS.find(
        (option) => option.value === filter,
    )!;
}
